import { IconWrapper } from '../runtime';
export default IconWrapper('tip_warning_tips', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 100 100",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "opacity": "0.4",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M59.3374 17.4937C55.032 10.5802 44.968 10.5802 40.6626 17.4937L8.47157 69.1851C3.90856 76.5122 9.17715 86 17.809 86H82.1911C90.8229 86 96.0915 76.5122 91.5285 69.1851L59.3374 17.4937ZM53.3712 23.7785C51.7984 21.3158 48.2017 21.3158 46.6289 23.7785L15.9297 71.847C14.2292 74.5096 16.1415 78 19.3008 78H80.6992C83.8585 78 85.7709 74.5096 84.0704 71.847L53.3712 23.7785Z",
      "fill": "#C0CADD"
    }
  }), h("path", {
    "attrs": {
      "opacity": "0.4",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M53.3712 23.7785C51.7984 21.3158 48.2017 21.3159 46.6289 23.7785L15.9297 71.847C14.2292 74.5096 16.1415 78 19.3008 78H80.6992C83.8585 78 85.7709 74.5096 84.0704 71.847L53.3712 23.7785ZM53.057 37.0415H48.1061C46.5798 37.0415 45.37 37.9139 45.4652 38.9459L47.7805 58.4545C47.8676 59.3993 49.0241 60.1353 50.4213 60.1353H50.7417C52.139 60.1353 53.2954 59.3993 53.3826 58.4545L55.6978 38.9459C55.793 37.9139 54.5833 37.0415 53.057 37.0415ZM54.5861 66.9098C54.5861 69.1727 52.7517 71.0071 50.4889 71.0071C48.226 71.0071 46.3916 69.1727 46.3916 66.9098C46.3916 64.6469 48.226 62.8125 50.4889 62.8125C52.7517 62.8125 54.5861 64.6469 54.5861 66.9098Z",
      "fill": "#8199B9"
    }
  }), h("path", {
    "attrs": {
      "opacity": "0.9",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M48.1061 37.0415H53.057C54.5833 37.0415 55.793 37.9139 55.6978 38.9459L53.3826 58.4545C53.2954 59.3993 52.139 60.1353 50.7417 60.1353H50.4213C49.0241 60.1353 47.8676 59.3993 47.7805 58.4545L45.4652 38.9459C45.37 37.9139 46.5798 37.0415 48.1061 37.0415ZM50.4889 71.0071C52.7517 71.0071 54.5861 69.1726 54.5861 66.9098C54.5861 64.6469 52.7517 62.8125 50.4889 62.8125C48.226 62.8125 46.3916 64.6469 46.3916 66.9098C46.3916 69.1726 48.226 71.0071 50.4889 71.0071Z",
      "fill": "white"
    }
  })]);
});